import { DealItem } from '@/lib/graphql/generated/graphql';
import { columnSortState } from '@/states/column-sort.state';
import { useAtomValue } from 'jotai';
import { ChevronDown, ChevronUp, ChevronsUpDown } from 'lucide-react';

export const SortIcon: React.FC<{ pointer: keyof DealItem }> = ({
  pointer,
}) => {
  const columnSorts = useAtomValue(columnSortState);
  const sortConfig = columnSorts.find((sort) => sort.id === pointer);

  if (!sortConfig) {
    return (
      <span className="ml-1 inline-flex text-gray-400">
        <ChevronsUpDown className="h-4 w-4" />
      </span>
    );
  }
  return (
    <span className="ml-1 inline-flex text-blue-600">
      {sortConfig.desc ? (
        <ChevronDown className="h-4 w-4" />
      ) : (
        <ChevronUp className="h-4 w-4" />
      )}
    </span>
  );
};
